var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrincipal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Principal",
    d: "M50,3H20A10,10,0,0,0,10,13V28A10,10,0,0,0,20,38H50A10,10,0,0,0,60,28V13A10,10,0,0,0,50,3Zm5,25a5.015,5.015,0,0,1-5,5H20a5.015,5.015,0,0,1-5-5V13a5.015,5.015,0,0,1,5-5H50a5.015,5.015,0,0,1,5,5ZM47.5,45.5A2.507,2.507,0,0,1,45,48H12.5A12.5,12.5,0,0,1,0,35.5V18a2.5,2.5,0,1,1,5,0V35.5A7.522,7.522,0,0,0,12.5,43H45A2.507,2.507,0,0,1,47.5,45.5ZM35,13a7.5,7.5,0,1,0,7.5,7.5A7.522,7.522,0,0,0,35,13Zm0,10a2.5,2.5,0,1,1,2.5-2.5A2.507,2.507,0,0,1,35,23Z",
    transform: "translate(0 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincipal);
export default __webpack_public_path__ + "static/media/Principal.bc88c9697f38037486351cafc819e5e5.svg";
export { ForwardRef as ReactComponent };